import {
  Box,
  Center,
  Circle,
  IconButton,
  Popover,
  PopoverBody,
  PopoverContent,
  PopoverFooter,
  PopoverHeader,
  PopoverTrigger,
  Portal,
  Spinner,
  Text,
} from "@chakra-ui/react";
import { Trans, t } from "@lingui/macro";
import { Icon } from "@src/components/ui-kit/Icon";
import { useStore } from "@src/utils/hooks";
import { observer } from "mobx-react-lite";
import { useEffect } from "react";
import { HeaderContainer, LinkToTable, NotificationList } from "./components";
import { usePollNotifications } from "./hooks";
import { NotificationSettings } from "./NotificationSettings";

const Popup = () => {
  const { notificationsStore: store } = useStore();

  usePollNotifications(store, {
    first: 7,
  });

  useEffect(() => {
    store.refetch?.();
  }, [store.notificationGroups.length]);

  return (
    <Popover
      boundary="scrollParent"
      isOpen={store.popoverDisclosure.isOpen}
      onClose={store.popoverDisclosure.onClose}
      onOpen={() => {
        store.popoverDisclosure.onOpen();
        store.refetch?.();
      }}
      placement="bottom-end"
    >
      <PopoverTrigger>
        <Box pos="relative">
          <IconButton
            aria-label={t`show notifications`}
            icon={<Icon w="6" h="6" name="bell-02" />}
            variant="ghost"
          />
          {store.unreadNotificationsCount !== 0 && (
            <Circle
              pos="absolute"
              top="0"
              right="0"
              mt="-1"
              bg={store.hasUnreadActions ? "red.500" : "gray.400"}
              size="5"
            >
              <Text color="white" fontSize="2xs" fontWeight="bold">
                {store.unreadNotificationsCount}
              </Text>
            </Circle>
          )}
        </Box>
      </PopoverTrigger>

      <Portal>
        <PopoverContent
          overflowY="scroll"
          w={{
            base: "100vw",
            md: "496px",
          }}
          maxH="calc(100vh - 55px)"
          _focus={{ shadow: "xl" }}
        >
          <PopoverHeader p="4">
            <HeaderContainer forModule="popup">
              <h2 className="text-xl">
                <Trans>Notifications</Trans>
              </h2>
              <NotificationSettings store={store} />
            </HeaderContainer>
          </PopoverHeader>

          <PopoverBody minH="300px" p="0">
            {store.isLoading ? (
              <Center w="full" minH="200px">
                <Spinner color="teal.500" />
              </Center>
            ) : (
              <NotificationList
                height="auto"
                items={store.visibleNotifications}
              />
            )}
          </PopoverBody>

          <PopoverFooter p="4" textAlign="center">
            <LinkToTable onClick={() => store.popoverDisclosure.onClose()} />
          </PopoverFooter>
        </PopoverContent>
      </Portal>
    </Popover>
  );
};

export default observer(Popup);
